import { useState, useEffect } from 'react';
import { Tabs, Tab, Box, Badge } from '@mui/material';
import RecomendacionTabs from '../components/tabs/CapacitacionesTabs/RecomendacionTabs';
import CapacitacionTabs from '../components/tabs/CapacitacionesTabs/CapacitacionTabs';
import { useAxios } from '../context/AxiosHookContext';

function CapacitacionesPage() {
  const [value, setValue] = useState(0);
  const [counts, setCounts] = useState({});
  const axios = useAxios();

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  const fetchCounts = async () => {
    try {
      const { data } = await axios.get('/trainings/unread-counts');
      setCounts(data.data);
    } catch (error) {
      console.error('Error fetching counts:', error);
    }
  };

  useEffect(() => {
    fetchCounts();
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="capacitaciones tabs"
        sx={{ mb: 2 }}
      >
        <Tab 
          label={
            <Badge badgeContent={counts['Recomendación']?.total || 0} color="error">
              Recomendación
            </Badge>
          } 
        />
        <Tab 
          label={
            <Badge badgeContent={counts['Capacitación']?.total || 0} color="error">
              Capacitación
            </Badge>
          } 
        />
      </Tabs>

      {value === 0 && (
        <Box>
          <RecomendacionTabs counts={counts['Recomendación']} onUpdate={fetchCounts} />
        </Box>
      )}

      {value === 1 && (
        <Box>
          <CapacitacionTabs counts={counts['Capacitación']} onUpdate={fetchCounts} />
        </Box>
      )}
    </Box>
  );
}

export default CapacitacionesPage;